module.exports = __webpack_public_path__ + "static/media/collection.a691360c.svg";